
class SequentialAnimator {
  constructor() {
    this.index = 0;// 次に動かす要素の位置
    this.photoIndex = 0; // 0は最初に見せる
    this.timerId = null;
    this.isPlaying = false;
    this.photoTimer = null;
  }

  // 1ステップ進めて、次のステップを再帰的にsetTimeoutで予約
  _step() {
    const selector = this.currentSelecter();
    if (!selector) {
      this.isPlaying = false;
      return;
    }

    const item = document.querySelector(selector)
    item.classList.add('is-visible');
    if (selector === '.image-01') {
      item.classList.add('front');
    }
    if (selector === '.image-02') {
      document.querySelector('.image-01').classList.remove('front');
    }

    const beforeSelector = this.beforeSelector();
    if (beforeSelector) {
      const beforeItem = document.querySelector(beforeSelector);
      this.photoTimer = setTimeout(() => {
        beforeItem.classList.remove('is-visible');
      }, this.interval()); // 次の要素が出る前に前の要素を消す
    }
    if (this.index < 3) {
      this.index++;
    }
    if (this.index == 3) {
      this.photoIndex++;
      if (this.photoIndex > 3) {
        this.photoIndex = 0; // ループ
      }
    }
    this.updateProgress();
    this.timerId = setTimeout(() => this._step(), this.interval());
  }

  play() {
    // 二重起動防止 & 完了後はリセットが必要
    if (this.isPlaying) return;
    this.isPlaying = true;

    this._step();
  }

  pause() {
    if (!this.isPlaying) return;
    this.isPlaying = false;
    clearTimeout(this.timerId);   // 次の要素の発火を止める(indexは保持)
    if (this.photoTimer) {
      clearTimeout(this.photoTimer); // 次の要素の発火を止める(photoIndexは保持)
    }
    this.timerId = null;
    this.photoTimer = null;
  }
  currentSelecter() {
    switch(this.index) {
      case 0:
        return '.p-hero';
      case 1:
        return '.p-hero__catch';
      case 2:
        return '.p-hero__photo';
      case 3:
        switch (this.photoIndex) {
          case 0:
            return '.image-01';
          case 1:
            return '.image-02';
          case 2:
            return '.image-03';
          case 3:
            return '.image-04';
          default:
            return null;
        }
      default:
        return null;
    }
  }
  beforeSelector() {
    if (this.index !== 3) return null;
    switch (this.photoIndex) {
      case 0:
        return '.image-04';
      case 1:
        return '.image-01';
      case 2:
        return '.image-02';
      case 3:
        return '.image-03';
      default:
        return null;
    }
  }
  updateProgress() {
    document.querySelector('.progress-01').classList.remove('is-active');
    document.querySelector('.progress-02').classList.remove('is-active');
    document.querySelector('.progress-03').classList.remove('is-active');
    document.querySelector('.progress-04').classList.remove('is-active');
    document.querySelector('.progress-05').classList.remove('is-active');
    document.querySelector('.progress-06').classList.remove('is-active');
    document.querySelector('.progress-07').classList.remove('is-active');
    switch (this.index) {
      case 0:
        document.querySelector('.progress-01').classList.add('is-active');
        break;
      case 1:
        document.querySelector('.progress-02').classList.add('is-active');
        break;
      case 2:
        document.querySelector('.progress-03').classList.add('is-active');
        break;
      case 3:
        switch (this.photoIndex) {
          case 1:
            document.querySelector('.progress-04').classList.add('is-active');
            break;
          case 2:
            document.querySelector('.progress-05').classList.add('is-active');
            break;
          case 3:
            document.querySelector('.progress-06').classList.add('is-active');
            break;
          case 0:
            document.querySelector('.progress-07').classList.add('is-active');
            break;
          default:
            break;
        }
      default:
        break;
    }
  }
  interval() {
    switch (this.index) {
      case 0:
        return 2000;
      case 1:
        return 2000;
      case 2:
        return 2000;
      case 3:
        return 4000;
      default:
        return null;
    }
  }
  reset(index) {
    clearTimeout(this.timerId);
    this.timerId = null;
    if (this.photoTimer) {
      clearTimeout(this.photoTimer);
      this.photoTimer = null;
    }
    if (index <= 3) {
      this.index = index;
      this.photoIndex = 0;
    } else {
      this.index = 3;
      this.photoIndex = (index + 2) % 4; // 4枚の写真をループ
    }
    switch (this.index) {
      case 0:
        document.querySelector('.p-hero').classList.remove('is-visible');
        document.querySelector('.p-hero__catch').classList.remove('is-visible');
        document.querySelector('.p-hero__photo').classList.remove('is-visible');
        document.querySelector('.image-01').classList.add('is-visible');
        document.querySelector('.image-01').classList.remove('front');
        document.querySelector('.image-02').classList.remove('is-visible');
        document.querySelector('.image-03').classList.remove('is-visible');
        document.querySelector('.image-04').classList.remove('is-visible');
        break;
      case 1:
        document.querySelector('.p-hero').classList.add('is-visible');
        document.querySelector('.p-hero__catch').classList.remove('is-visible');
        document.querySelector('.p-hero__photo').classList.remove('is-visible');
        document.querySelector('.image-01').classList.add('is-visible');
        document.querySelector('.image-01').classList.remove('front');
        document.querySelector('.image-02').classList.remove('is-visible');
        document.querySelector('.image-03').classList.remove('is-visible');
        document.querySelector('.image-04').classList.remove('is-visible');
        break;
      case 2:
        document.querySelector('.p-hero').classList.add('is-visible');
        document.querySelector('.p-hero__catch').classList.add('is-visible');
        document.querySelector('.p-hero__photo').classList.remove('is-visible');
        document.querySelector('.image-01').classList.add('is-visible');
        document.querySelector('.image-01').classList.remove('front');
        document.querySelector('.image-02').classList.remove('is-visible');
        document.querySelector('.image-03').classList.remove('is-visible');
        document.querySelector('.image-04').classList.remove('is-visible');
        break;
      case 3:
        document.querySelector('.p-hero').classList.add('is-visible');
        document.querySelector('.p-hero__catch').classList.add('is-visible');
        document.querySelector('.p-hero__photo').classList.add('is-visible');
        switch (this.photoIndex) {
          case 1:
            document.querySelector('.image-01').classList.add('is-visible');
            document.querySelector('.image-01').classList.remove('front');
            document.querySelector('.image-02').classList.remove('is-visible');
            document.querySelector('.image-03').classList.remove('is-visible');
            document.querySelector('.image-04').classList.remove('is-visible');
            break;
          case 2:
            document.querySelector('.image-01').classList.remove('is-visible');
            document.querySelector('.image-01').classList.remove('front');
            document.querySelector('.image-02').classList.add('is-visible');
            document.querySelector('.image-03').classList.remove('is-visible');
            document.querySelector('.image-04').classList.remove('is-visible');
            break;
          case 3:
            document.querySelector('.image-01').classList.remove('is-visible');
            document.querySelector('.image-01').classList.remove('front');
            document.querySelector('.image-02').classList.remove('is-visible');
            document.querySelector('.image-03').classList.remove('is-visible');
            document.querySelector('.image-04').classList.add('is-visible');
            break
          case 0:
            document.querySelector('.image-01').classList.remove('is-visible');
            document.querySelector('.image-01').classList.add('front');
            document.querySelector('.image-02').classList.remove('is-visible');
            document.querySelector('.image-03').classList.remove('is-visible');
            document.querySelector('.image-04').classList.add('is-visible');
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
    this.updateProgress();
    this.timerId = setTimeout(() => this._step(), this.interval());
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const animator = new SequentialAnimator();
  setTimeout(() => {
    animator.play();
  }, 2000);
  const btn = document.getElementById('hero-play-btn');
  btn.addEventListener('click', () => {
    if (animator.isPlaying) {
      animator.pause();
      btn.classList.add('is-paused');
    } else {
      animator.play();
      btn.classList.remove('is-paused');
    }
  });

  const progressItems = document.querySelectorAll('.p-hero__progress-item');
  progressItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      animator.reset(index);
    });
  });
});
